'use strict';

var _handlebarsMin = require('handlebars/dist/handlebars.min.js');

var _handlebarsMin2 = _interopRequireDefault(_handlebarsMin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('jquery-sticky-kit/dist/sticky-kit.min.js');

var defaultProductSort;

$(document).ready(function () {

	document.addEventListener('lazybeforeunveil', function (e) {
		var bg = e.target.getAttribute('data-bg');
		if (bg) {
			e.target.style.backgroundImage = 'url(' + bg + ')';
		}
	});

	var collectionHandle = $('.collection-header').data('collection-handle');

	// Get ALL products in collection for now. We are lazyloading images, should be fast enough.
	var ajaxDone = false;
	var ajaxPromises = [];
	$('.collection-grid .loading-spinner').show();
	var jqxhr1 = $.getJSON('/collections/' + collectionHandle + '/product_count.json', function () {
		// console.log( "successfully retreived count json" );
	}).done(function (data1) {
		var productCount = data1.collection.products_count;
		var pageCount = Math.ceil(productCount / 250);
		var page = 1;
		for (var i = 0; i < pageCount; i++) {
			var jqxhr2 = $.getJSON('/collections/' + collectionHandle + '/products.json?limit=250&page=' + page, function () {
				// console.log( "successfully retreived products json" );
			}).done(function (data2) {
				// Default sort will be whatever is set in Shopify admin for the collection. Most likely sort is by "Best Selling"
				defaultProductSort = data2.products;
				var defaultSort = 1;
				$.each(data2.products, function (i, product) {
					var source = document.getElementById("product_grid_item").innerHTML;
					var template = _handlebarsMin2.default.compile(source);
					var productDate = new Date(product.created_at);
					var productTags = $.map(product.tags, function (n, i) {
						return Shopify.handleize(n);
					});
					var productVendor = Shopify.handleize(product.vendor);
					var context = {
						default_sort: defaultSort,
						product_url: '/collections/' + collectionHandle + '/products/' + product.handle,
						product_title: product.title,
						product_img: product.images[0].src.replace('.jpg', '_large.jpg'),
						product_price_filter: product.variants[0].price,
						product_price: formatCurrency(product.variants[0].price),
						product_tags: productTags.join(' '),
						product_date: productDate.getTime() / 1000,
						product_vendor: productVendor
					};
					var html = template(context);
					$(html).appendTo('#product-grid').removeClass('hidden');
					defaultSort++;
				});
			});
			page++;
			ajaxPromises.push(jqxhr2);
		}
		$.when.apply(null, ajaxPromises).done(function () {
			$('.collection-grid .loading-spinner').fadeOut();
			if (GetURLParameter('price')) {
				$('.collection-filter-by-price a[data-price-filter="' + GetURLParameter('price') + '"]').trigger('click');
			}
		});
	});

	$('.dropdown-wrap .dropdown').mouseleave(function () {
		$(this).find('.dropdown-options').slideUp('fast');
	});

	$('.collection-sort-by a').on('click', function (e) {
		e.preventDefault();
		var sort = $(this).data('sort-by');

		if ($(this).hasClass('active')) {
			// Don't do anything if this is already the active sort.
			return false;
		}

		$('.collection-sort-by a').removeClass('active');
		$(this).addClass('active');

		// Sorting logic
		var products = $('.pgi');
		if (sort == 'default') {
			products.sort(function (a, b) {
				return $(a).data("default-sort") - $(b).data("default-sort");
			});
			$("#product-grid").html(products);
		} else if (sort == 'created-descending') {
			products.sort(function (a, b) {
				return $(b).data("date") - $(a).data("date");
			});
			$("#product-grid").html(products);
		} else if (sort == 'price-ascending') {
			products.sort(function (a, b) {
				return $(a).data("price") - $(b).data("price");
			});
			$("#product-grid").html(products);
		} else if (sort == 'price-descending') {
			products.sort(function (a, b) {
				return $(b).data("price") - $(a).data("price");
			});
			$("#product-grid").html(products);
		} else if (sort == 'title-ascending') {
			products.sort(function (a, b) {
				return String.prototype.localeCompare.call($(a).data('product-title').toLowerCase(), $(b).data('product-title').toLowerCase());
			});
			$("#product-grid").html(products);
		} else if (sort == 'title-descending') {
			products.sort(function (a, b) {
				return String.prototype.localeCompare.call($(b).data('product-title').toLowerCase(), $(a).data('product-title').toLowerCase());
			});
			$("#product-grid").html(products);
		} else {
			// Do Nothing
		}
	});

	$('.collection-filter-by-brand a').on('click', function (e) {
		e.preventDefault();
		var brandFilter = $(this).data('brand-filter');
		var products = $('.pgi');

		if ($(this).hasClass('active')) {
			$('.pgi').show();
			$('.collection-filter-by-brand a').removeClass('active');
			return false;
		}

		// Filtering logic
		// Reset First
		$('.pgi').show();
		$('.collection-filter-by-brand a').removeClass('active');
		$(this).addClass('active');
		products.each(function (i) {
			if ($(this).data('brand') != brandFilter) {
				$(this).hide();
			} else {
				$(this).show();
			}
		});
	});

	$('.collection-filter-by-tag a').on('click', function (e) {
		e.preventDefault();
		var tagFilter = $(this).data('tag-filter');
		var products = $('.pgi');

		if ($(this).hasClass('active')) {
			$('.pgi').show();
			$('.collection-filter-by-tag a').removeClass('active');
			return false;
		}

		// Filtering logic
		// Reset First
		$('.pgi').show();
		$('.collection-filter-by-tag a').removeClass('active');
		$(this).addClass('active');
		products.each(function (i) {
			if (!$(this).hasClass(tagFilter)) {
				$(this).hide();
			} else {
				$(this).show();
			}
		});
	});

	$('.collection-filter-by-price a').on('click', function (e) {
		e.preventDefault();
		var priceFilter = $(this).data('price-filter');
		var products = $('.pgi');

		if ($(this).hasClass('active')) {
			$('.pgi').show();
			$('.collection-filter-by-price a').removeClass('active');
			return false;
		}

		// Filtering logic
		// Reset First
		$('.pgi').show();
		$('.collection-filter-by-price a').removeClass('active');
		$(this).addClass('active');

		var price = priceFilter.replace('under-', '');

		products.each(function (i) {
			if (parseInt($(this).data('price')) > parseInt(price)) {
				$(this).hide();
			} else {
				$(this).show();
			}
		});
	});
});

function formatCurrency(total) {
	var neg = false;
	if (total < 0) {
		neg = true;
		total = Math.abs(total);
	}
	return (neg ? "-$" : '$') + parseFloat(total, 10).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,").toString();
}

function GetURLParameter(sParam) {
	var sPageURL = window.location.search.substring(1);
	var sURLVariables = sPageURL.split('&');
	for (var i = 0; i < sURLVariables.length; i++) {
		var sParameterName = sURLVariables[i].split('=');
		if (sParameterName[0] == sParam) {
			return sParameterName[1];
		}
	}
}

Shopify.handleize = function (str) {
	str = str.toLowerCase();
	var toReplace = ['"', "'", "\\", "(", ")", "[", "]"];
	// For the old browsers
	for (var i = 0; i < toReplace.length; ++i) {
		str = str.replace(toReplace[i], "");
	}
	str = str.replace(/\W+/g, "-");
	if (str.charAt(str.length - 1) == "-") {
		str = str.replace(/-+\z/, "");
	}
	if (str.charAt(0) == "-") {
		str = str.replace(/\A-+/, "");
	}
	return str;
};